interface GroupedDropdownSelection {
  groupLabel: string
  optionLabel: Nullable<string>
  group: { id: number | string; name: string }
  option: Nullable<{ id: number | string; name: string }>
}

export const composeGroupedDropdownReply = ({
  groupLabel,
  optionLabel,
  group,
  option,
}: GroupedDropdownSelection): string => {
  const groupSegment = `${groupLabel}: ${group.name} (id ${group.id})`

  if (!option || !optionLabel) return groupSegment

  return `${groupSegment}, ${optionLabel}: ${option.name} (id ${option.id})`
}
